// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Wjq3G","right":"styles_right__15eBq"};